Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _react = require("react");
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var _Header = require("../Header");
var useStyles = exports.useStyles = function useStyles(_ref) {
  var hideLabel = _ref.hideLabel;
  var _useContext = (0, _react.useContext)(_Header.HeaderContext),
    backgroundColor = _useContext.backgroundColor;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing,
    colors = _STYLES$useStyles.colors,
    fontRegular = _STYLES$useStyles.fontRegular,
    bp = _STYLES$useStyles.bp,
    boxShadows = _STYLES$useStyles.boxShadows,
    COLORS = _STYLES$useStyles.COLORS;
  var _itemSize = 2.5;
  var _borderSize = 0.125;
  var _iconSize = _itemSize - _borderSize * 2;
  var _spacing = spacing.xxs;
  if (hideLabel) {
    _spacing = spacing.xs;
    if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
      _spacing = spacing.xxs;
    }
  }
  var paging = {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: spacing.xs,
    marginRight: _reactNative.Platform.OS === 'web' ? "-".concat(_spacing) : -_spacing,
    marginLeft: _reactNative.Platform.OS === 'web' ? "-".concat(_spacing) : -_spacing,
    alignItems: 'center',
    justifyContent: 'center',
    gap: _reactNative.Platform.OS === 'web' ? "calc(".concat(_spacing, " * 2)") : _spacing * 2
  };
  var pagingItemNativeContainer = Object.assign({}, boxShadows.button.ios, {
    backgroundColor: COLORS.white,
    borderRadius: (0, _styles.getREM)(_itemSize / 2)
  });
  var pagingItem = Object.assign({}, fontRegular, {
    width: (0, _styles.getREM)(_itemSize),
    height: (0, _styles.getREM)(_itemSize),
    borderRadius: (0, _styles.getREM)(_itemSize / 2),
    borderColor: colors.brand,
    borderWidth: (0, _styles.getREM)(_borderSize),
    borderStyle: 'solid',
    backgroundColor: backgroundColor || colors.brandContrast,
    color: colors.text,
    overflow: 'hidden',
    fontSize: _styles.STYLES.fontSize.normal
  }, boxShadows.button.web, boxShadows.button.android, {
    textAlign: 'center',
    lineHeight: (0, _styles.getREM)(_iconSize)
  });
  if (_reactNative.Platform.OS === 'android') {
    pagingItem.lineHeight = (0, _styles.getREM)(_itemSize);
  }
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m])) {
    pagingItem.fontSize = _styles.STYLES.fontSize.s;
  }
  var pagingItem_current = {
    backgroundColor: colors.brand,
    borderColor: colors.brand,
    color: colors.brandContrast
  };
  var pagingItem_pointerOver = Object.assign({}, boxShadows.button_pointerOver.web);
  var ellipsis = Object.assign({}, fontRegular, {
    color: colors.text,
    fontSize: _styles.STYLES.fontSize.normal,
    lineHeight: _styles.STYLES.lineHeight.normal
  });
  var iconLeft = {
    width: (0, _styles.getREM)(_iconSize / 2),
    height: (0, _styles.getREM)(_iconSize / 2),
    marginRight: (0, _styles.getREM)(_iconSize / 16)
  };
  var iconRight = {
    width: (0, _styles.getREM)(_iconSize / 2),
    height: (0, _styles.getREM)(_iconSize / 2),
    marginLeft: (0, _styles.getREM)(_iconSize / 8)
  };
  if (_reactNative.Platform.OS === 'ios') {
    iconLeft.marginTop = (0, _styles.getREM)(_iconSize / 4);
    iconRight.marginTop = (0, _styles.getREM)(_iconSize / 4);
    iconRight.marginLeft = (0, _styles.getREM)(_iconSize / 4);
  }
  var iconContainer = {
    width: (0, _styles.getREM)(_iconSize),
    height: (0, _styles.getREM)(_iconSize),
    justifyContent: 'center'
  };
  var styles = _reactNative.StyleSheet.create({
    paging: paging,
    pagingItemNativeContainer: pagingItemNativeContainer,
    pagingItem: pagingItem,
    pagingItem_current: pagingItem_current,
    pagingItem_pointerOver: pagingItem_pointerOver,
    ellipsis: ellipsis,
    iconLeft: iconLeft,
    iconRight: iconRight,
    iconContainer: iconContainer
  });
  return {
    styles: styles
  };
};